export class Load{
	init(){
		setTimeout(function() {
			document.body.classList.add('render');
		}, 60);
		var self = this;
		var a = Array.from(document.querySelectorAll('a:not(.picture):not(.mini-gallery__link):not(.embed):not(.js-wis2-open-booking):not(.button--reservation):not(.download__link)'));

		a.forEach(function(el) {
			el.addEventListener('click', function(ev){
				var target = ev.currentTarget;
				var check = target.href.match(/\bdownload|^[tmf]|^\#$/gm);

				if(check != null){
					ev.preventDefault();
					self.navigate(target);
				}
			});
		});
	}
	navigate(linkEl){
		document.getElementsByTagName('html')[0].classList.add('no-scroll');
		document.body.classList.remove('render');
		document.body.addEventListener('transitionend', function(){
			window.location = linkEl.href;
		});
	}
}